var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.name
    ? _c(
        "CheckPermission",
        { attrs: { permission: "ADM30" } },
        [
          _c("b-overlay", { attrs: { show: _vm.loading, "no-wrap": "" } }),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-8 d-flex align-items-end" },
              [
                _c("label", [_vm._v(_vm._s(_vm.name))]),
                _c("InfoApprovalSigns")
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-2" },
              [
                _c(
                  "vs-radio",
                  {
                    attrs: {
                      "data-cy": "parameter" + _vm.paramId + "-yes",
                      disabled: _vm.disabled,
                      "vs-name": "parameter",
                      "vs-value": true,
                      value: _vm.value
                    },
                    on: {
                      input: function($event) {
                        return _vm.$emit("input", $event)
                      }
                    }
                  },
                  [_vm._v(" Si ")]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-2" },
              [
                _c(
                  "vs-radio",
                  {
                    attrs: {
                      "data-cy": "parameter" + _vm.paramId + "-no",
                      disabled: _vm.disabled,
                      "vs-name": "parameter",
                      "vs-value": false,
                      value: _vm.value
                    },
                    on: {
                      input: function($event) {
                        return _vm.$emit("input", $event)
                      }
                    }
                  },
                  [_vm._v(" No ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }